module.exports = __webpack_public_path__ + "img/96.d20deaff.svg";